import React, { useEffect, useState } from "react";
import { ButtonsContainer, Button } from "@components";
import { splitModuleSettings } from "./util";
import { ModuleSetting, RootProductId } from "@models";
import styled from "styled-components";
import { StyledModuleSettingCard } from "./ModuleSettingCategorySection";

type Props = {
	showActiveModuleSettings: boolean;
	moduleSettings: ModuleSetting[];
	rootProductId: RootProductId;
	handleCopyModuleSetting: (ms: ModuleSetting) => void;
};

export default function ExistingModuleSettings(props: Props) {
	const { showActiveModuleSettings, moduleSettings, rootProductId } = props;
	const [showExpired, setShowExpired] = useState(false);
	const [showInFuture, setShowInFuture] = useState(false);

	useEffect(() => {
		setShowExpired(!showActiveModuleSettings);
		setShowInFuture(!showActiveModuleSettings);
	}, [showActiveModuleSettings]);

	const { activeModuleSettings, expiredModuleSettings, futureModuleSettings } =
		splitModuleSettings(moduleSettings);

	const showExpiredModuleSettingsButton =
		!showExpired &&
		expiredModuleSettings.length > 0 &&
		showActiveModuleSettings;
	const showFutureModuleSettingsButton =
		!showInFuture &&
		futureModuleSettings.length > 0 &&
		showActiveModuleSettings;
	return (
		<>
			{showFutureModuleSettingsButton && (
				<StyledButtonContainer>
					<StyledButton
						type="button"
						onClick={() => {
							setShowInFuture(true);
						}}
						data-testid="showFutureMS-button"
					>
						... {futureModuleSettings.length} zukünftige anzeigen
					</StyledButton>
				</StyledButtonContainer>
			)}
			{showInFuture &&
				futureModuleSettings.map((ms) => (
					<StyledModuleSettingCard
						key={ms.moduleSettingId}
						rootProductId={rootProductId}
						moduleSetting={ms}
						onCopy={() => props.handleCopyModuleSetting(ms)}
					/>
				))}
			{activeModuleSettings.map((ms) => (
				<StyledModuleSettingCard
					key={ms.moduleSettingId}
					rootProductId={rootProductId}
					moduleSetting={ms}
					onCopy={() => props.handleCopyModuleSetting(ms)}
				/>
			))}
			{showExpiredModuleSettingsButton && (
				<StyledButtonContainer>
					<StyledButton
						type="button"
						onClick={() => {
							setShowExpired(true);
						}}
						data-testid="showExpiredMS-button"
					>
						... {expiredModuleSettings.length} ausgelaufene anzeigen
					</StyledButton>
				</StyledButtonContainer>
			)}
			{showExpired &&
				expiredModuleSettings.map((ms) => (
					<StyledModuleSettingCard
						key={ms.moduleSettingId}
						rootProductId={rootProductId}
						moduleSetting={ms}
						onCopy={() => props.handleCopyModuleSetting(ms)}
					/>
				))}
		</>
	);
}

const StyledButtonContainer = styled(ButtonsContainer)`
	margin: 16px;
`;

const StyledButton = styled(Button).attrs({
	variant: "outline-secondary",
})``;
